module.exports = __webpack_public_path__ + "static/media/cantonese_vocabulary_table_2.d0b932ec.png";